import { SVG, SVGProps } from './svg'

export function IconDrawingSettingHide(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="m7.2 16.8-.6-.8a19.8 19.8 0 0 1 2.7-3.1C11 11 13.4 9.5 16 9.5c2.6 0 5 1.6 6.7 3.4a22 22 0 0 1 2.7 3v.1a19.9 19.9 0 0 1-2.7 3.1C21 21 18.6 22.5 16 22.5c-2.6 0-5-1.6-6.7-3.4a22 22 0 0 1-2.1-2.3Zm19.2-1-.4.2.4.3a5.3 5.3 0 0 1-.2.3 20.8 20.8 0 0 1-2.8 3.3c-1.8 1.7-4.4 3.6-7.4 3.6s-5.6-1.9-7.4-3.6a23 23 0 0 1-3-3.6L6 16l-.4-.3a7.3 7.3 0 0 1 .2-.3 20.8 20.8 0 0 1 2.8-3.3c1.8-1.7 4.4-3.6 7.4-3.6s5.6 1.9 7.4 3.6a23 23 0 0 1 3 3.6Zm-.4.2.4-.3.2.3-.2.3-.4-.3Zm-20.4-.3.4.3-.4.3-.2-.3.2-.3Zm7.9.3a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"
      />
    </SVG>
  )
}
